var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.keepAlive)?_c('keep-alive',[_c('RouterView',{key:_vm.$route.name})],1):_c('RouterView',{key:_vm.routerViewKey})],1)}
var staticRenderFns = []

export { render, staticRenderFns }